/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import NutritionIP from './nutrition-ip';
import NutritionIPDetail from './nutrition-ip-detail';
import NutritionIPUpdate from './nutrition-ip-update';
import NutritionIPDeleteDialog from './nutrition-ip-delete-dialog';

const NutritionIPRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<NutritionIP />} />
    <Route path="new" element={<NutritionIPUpdate />} />
    <Route path=":id">
      <Route index element={<NutritionIPDetail />} />
      <Route path="edit" element={<NutritionIPUpdate />} />
      <Route path="delete" element={<NutritionIPDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default NutritionIPRoutes;
